import "./Home.css";
import { useRef, useEffect } from "react";

export default function About({ destinazione }) {
    const showroom = useRef(null);

    useEffect(() => {
        if (destinazione == "showroom")
            showroom.current.scrollIntoView({ behavior: "smooth" })
    })

    const scrollDx = () => {
        var dx = document.querySelector(".slideshow");
        dx.scrollBy(350, 0)
    }
    const scrollSx = () => {
        var sx = document.querySelector(".slideshow");
        sx.scrollBy(-350, 0)
    }

    const scrollDx2 = () => {
        var dx = document.querySelector("#slideshow");
        dx.scrollBy(350, 0)
    }
    const scrollSx2 = () => {
        var sx = document.querySelector("#slideshow");
        sx.scrollBy(-350, 0)
    }

    return (
        <section>
            <h1> Storia </h1>
            <br/>
            <div className="cover"><div className="slideshow">
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/about (1).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/about (2).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/about (3).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/about (4).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/about (5).jpg" loading="lazy"/>
                </div>
            </div></div>
            <div className="frecce">
                <ion-icon id="frecce_slideshow" onClick={scrollSx} name="chevron-back-outline"></ion-icon>
                <p className="help">
                scorri per visualizzare le immagini
                </p>
                <ion-icon id="frecce_slideshow" onClick={scrollDx} name="chevron-forward-outline"></ion-icon>
            </div>
            <br/>
            <p> <i>Infis Lab</i> è un'azienda che opera nel settore <b>dal lontano 1974</b>. Avviata
                da papà Gaetano, è stata portata avanti dai suoi figli con nuove idee, progetti,
                innovazioni e collaborazioni con professionisti di questo ambiente. <br /><br />
            </p>
            <p>
                Il nostro punto di forza è l'<b>esperienza</b>, maturata grazie ai numerosi lavori che
                spaziano dal manufatto artigianale all'installazione di infissi di alta qualità.<br /><br />
                La nostra priorità è che ogni lavoro commissionato venga sempre portato a termine
                in maniera scrupolosa. Garantiamo la <b>qualità</b> con personale certificato nella posa di
                infissi e con attrezzature costantemente al passo con i tempi.<br /><br />
            </p>
            <h1 ref={showroom}> Showroom </h1>
            <br/>
            <div className="cover"><div className="slideshow" id="slideshow">
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/showroom (1).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/showroom (2).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/showroom (3).jpg" loading="lazy"/>
                </div>
                <div className="slideshow_element">
                    <img className="img_about" src="https://infislab.it/foto/sezioni/showroom (4).jpg" loading="lazy"/>
                </div>
            </div></div>
            <div className="frecce">
                <ion-icon id="frecce_slideshow" onClick={scrollSx2} name="chevron-back-outline"></ion-icon>
                <p className="help">
                scorri per visualizzare le immagini
                </p>
                <ion-icon id="frecce_slideshow" onClick={scrollDx2} name="chevron-forward-outline"></ion-icon>
            </div>
            <br/>
            <p> Immergiti in uno spazio fatto di infissi e cataloghi, confrontati
                con un esperto che ti sappia consigliare: troverai la soluzione più
                adatta a te.
            </p> 
            <br/>
            <div className="icons_about">
                <ion-icon id="icone_home" name="location-outline"></ion-icon>
                <p className="caption"> Lo showroom si trova a <a className="a_about"
                href="https://goo.gl/maps/K5jNsuzMBiULRTQD7" target="_blank">Cassano delle Murge (BA),
                in <i>via Grumo, 8</i></a>.</p>
            </div>
            <br/>
            <div className="icons_about">
                <ion-icon id="icone_home" name="time-outline"></ion-icon>
                <p className="caption">Siamo aperti da lunedì a venerdì,
                ore 18:00-21:00.</p>
            </div>
            <br/>
            <div className="icons_about">
                <ion-icon id="icone_home" name="list-circle-outline"></ion-icon>
                <p className="caption"> Vuoi essere sicuro di trovarci? <br/><br/>
                Scrivi o chiama al seguente
                numero: <a className="a_about" href="tel:+393288921372">3288921372</a><br/><br/> 
                Contattaci all'indirizzo: <a className="a_about"
                href="mailto:infislab@gmail.com">infislab@gmail.com</a><br/><br/>
                Scrivici su Facebook alla pagina: <a className="a_about"
                href="https://it-it.facebook.com/infislab/" target="_blank">Infis Lab</a></p>
            </div>
        </section>
    )
}